<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ノートの内訳</span>
        </div>
        <div class="popup-content">
          <p class="txt pt40 ml40 mr40">ノートはご購入いただいているライセンスの数により、作成可能な数を設定しております。</p>
          <div class="license-num">
            <p>作成数</p>
            <p class="license-num-txt"><span :class="{max: noteIsMax }">{{contract.note_number}}</span> / <span>{{contract.note_number_max}}</span></p>
            <p>上限数</p>
          </div>
          <div class="license-inner" style="overflow-y:auto;max-height:450px;">
            <ul class="column gutter license-list">
              <li
                v-for="(user, index) in sortedUsers" :key="user.id"
                :class="['column-item', 'col-4', 'space-gutter', 'license-list-item', user.status === 2 && 'stopped']"
                >
                <div class="license-box">
                  <div class="license-box-hdg" :index="index" :style="titleHeight(index)" :ref="'boxTitle' + index">
                    <span>{{user.note_number ? user.note_number : 0}}<span class="license-box-hdg-unit">冊</span></span>
                  </div>
                  <div class="license-box-content">
                     <div class="license-box-content-user">
                        <span v-if="user.file_id > 0" class="license-box-content-user-thumb" :style="{backgroundImage : 'url(' + user.image + ')'}"></span>
                        <span v-else class="license-box-content-user-thumb no-image">{{user.name.slice(0, 1)}}</span>
                        <span class="license-box-content-user-name">{{user.name}}</span>
                     </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContractNote } from '@/logic/contract/ContractNote'
import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  name: 'PCContractNoteBreakdown',
  setup (props, context) {
    return {...ContractNote(context)}
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 0 0 40px!important;
}
.license-num {
  display: flex;
  color: $color-sup;
  align-items: center;
  font-size: 1.4rem;
  float: right;
  margin-bottom: 14px;
  margin-top: 20px;
  margin-right: 40px;
  p {
    margin-left: 12px;
  }
  &-txt {
    font-size: 2rem;
    color: $color-hdg;
    font-weight: bold;
    margin-top: -2px;
    .max {
      color: $color-highlight;
    }
  }
}
.license-inner {
  width: 100%;
  .column {
    padding: 0 30px;
  }
}
.license-list{
  clear: both;
  list-style: none;
  margin: 0 0 32px!important;
  &-item {
    border: 1px solid $color-line;
    border-radius: 4px;
    &.stopped{
      .license-box-hdg {
        color: $color-inactive;
      }
    }
  }
}
.license-box {
  &-hdg {
    text-align: center;
    font-size: 3.2rem;
    font-weight: bold;
    padding: 25px 10px 27px;
    color: $color-hdg;
    .max {
      color: $color-highlight;
    }
    &-unit {
      font-size: 2rem;
    }
    &-desc {
      font-size: 1.6rem;
      color: $color-content;
      display: block;
      text-align: center;
      font-weight: normal;
      margin-top: 4px;
    }
  }
  &-content{
    border-top: 1px solid $color-line;
    padding: 23px 40px;
    .txt {
      line-height: 1.625;
      font-weight: 600;
      margin-bottom: 5px;
    }
    &-user {
      display: flex;
      align-items: center;
      &-name {
        font-size: 1.6rem;
      }
      &-thumb {
        display: block;
        height: 36px;
        width: 36px;
        margin-left: 10px;
        background-position: center;
        background-size: cover;
        border-radius: 18px;
        border: 1px solid #fff;
        margin-right: 11px;
        @include profileImage()
      }
    }
  }
}
</style>
